import React from 'react'

type PaymentFieldsProps = {
  register:any
  errors:any
  setValue:any
  clearError?:any
  reset?:any
}


function CreditCardPaymentFields(props:PaymentFieldsProps){

  const { register, errors, setValue, clearError } = props
  // const [ result, setResult ] = useState('')
  // const [ resultMsg, setResultMsg ] = useState<string>('')

  return(
    <div className="stb_form_payment">
      
      <fieldset className="stb_form_payment_set">
        <label>카드 번호</label>
        <input type='text' maxLength={19} className='stb_form_payment_input' placeholder="'-'를 빼고 입력하세요." name='cardNumber' ref={register({required:true, maxLength: 19, minLength: 18, 
            //  pattern:/^\d+$/
            })}
          onChange={e => {
            clearError('cardNumber');
            setValue(
              'cardNumber',
              e.target.value.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim()
            );
          }}
        ></input>
        {errors.cardNumber?.type === 'required' && <div className="stb_form_msg_error" id="cardNumber">카드번호를 입력하세요.</div>}
        {errors.cardNumber?.type === 'minLength' && <div className="stb_form_msg_error" id="cardNumber">잘못된 카드번호입니다.</div>}
        {errors.cardNumber?.type === 'maxLength' && <div className="stb_form_msg_error" id="cardNumber">잘못된 카드번호입니다.</div>}
        {/* {errors.cardNumber?.type === 'pattern' && <div className="stb_form4_msg_error" id="cardNumber">잘못된 카드번호입니다. 숫자만 입력할 수 있습니다.</div>} */}
      </fieldset>

      <fieldset className="stb_form_payment_set">
        <label>유효 기간</label>
        <input type='text' maxLength={7} className='stb_form_payment_expiry' name='expiry' placeholder="월 / 연" ref={register({required:true, maxLength:7, minLength:7})}
        //onkeydown했을때 onchnage 작동 안하도록?
        onKeyDown={e=>{
          if (e.keyCode === 8) { 
            if(e.currentTarget.value.length === 4){
              setValue(
                'expiry',
                e.currentTarget.value.replace(/[^\dA-Z]/g, '').replace(/(.{2})/g, '$1 / ').trim().substring(0,2)
              );
            }
            return;

          }
          }}
        onChange={e => {
          clearError('expiry');
          if(e.target.value.length)
          setValue(
            'expiry',
            e.target.value.replace(/[^\dA-Z]/g, '').replace(/(.{2})/, '$1 / ').trim().substring(0,7)
          );
        }}
        ></input>
        {errors.expiry?.type === 'required' && <div className="stb_form_msg_error">유효 기간을 입력하세요.</div>}
        {errors.expiry?.type === 'maxLength' && <div className="stb_form_msg_error">유효 기간을 입력하세요.</div>}
        {errors.expiry?.type === 'minLength' && <div className="stb_form_msg_error">유효 기간을 입력하세요.</div>}
      </fieldset>

      <fieldset className="stb_form_payment_set">
        <label>카드 비밀번호 앞 2자리</label>
        <input type='password' maxLength={2} className='stb_form_payment_pw' name='password2Digit' ref={register({required:true, maxLength:2, minLength:2, pattern:/^\d+$/})}></input> <span className="pw_asterisk">**</span>
        {errors.password2Digit?.type === 'required' && <div className="stb_form_msg_error">카드 비밀번호 앞 2자리를 입력하세요.</div>}
        {errors.password2Digit?.type === 'maxLength' && <div className="stb_form_msg_error">카드 비밀번호 앞 2자리를 입력하세요.</div>}
        {errors.password2Digit?.type === 'minLength' && <div className="stb_form_msg_error">카드 비밀번호 앞 2자리를 입력하세요.</div>}
        {errors.password2Digit?.type === 'pattern' && <div className="stb_form_msg_error">잘못된 비밀번호입니다. 숫자만 입력할 수 있습니다.</div>}
      </fieldset>

      <fieldset className="stb_form_payment_set">
        <label>생년월일 6자리(개인) / 사업자등록번호 10자리(법인)</label>
        <p>법인명과 개인 이름이 함께 표시된 경우, 개인의 생년월일을 입력하세요.</p>
        <input type='text' maxLength={10} className='stb_form_payment_input' placeholder="'-'를 빼고 입력하세요." name='birth' ref={register({required:true, pattern:/^\d+$/})}></input>
        {errors.birth?.type === 'required' && <div className="stb_form_msg_error" id="birth">생년월일 또는 사업자등록번호를 입력하세요.</div>}
        {errors.birth?.type === "pattern" && <div className="stb_form_msg_error" id="birth">숫자만 입력할 수 있습니다.</div>}
      </fieldset>
      {/* <div className={`stb_form_result ${result}`}  id="stb_form_result">
        <p>{resultMsg}</p>
      </div> */}
    </div>
  )
}

export default CreditCardPaymentFields